import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedMenu: "Overview",
  documentationVersion: "V1",
};

const docsSlice = createSlice({
  name: "docs",
  initialState: initialState,
  reducers: {
    setDocumentationVersion(state, action) {
      state.documentationVersion = action.payload.documentationVersion;
    },
    setSelectedMenu(state, action) {
      state.selectedMenu = action.payload.selectedMenu;
    },
  },
});

export const { setDocumentationVersion,setSelectedMenu } = docsSlice.actions;
export const docsSliceReducer = docsSlice.reducer;
